import BaseModel from "./BaseModel";
import Course from "./Course";

/**
 * Cart
 */
export default class Cart extends BaseModel{

  constructor({
    id,
    course,
    user
  }) {
    super();
    
    this.id = id || null;
    this.course = course || null;
    this.user = user || null;

    if (this.course && !Number.isInteger(this.course)) {
      this.course = new Course(this.course);
    }
  }
}